(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sf-filter"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';
    var MOBIL = 860;
    function qa(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
    function absenden(form) {
      if (form.requestSubmit) form.requestSubmit(); else form.submit();
    }
    /* leere Zahlenfelder nicht mitsenden (saubere URL) */
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (f && f.matches && f.matches('form[data-sf-filterform]')) {
        qa('input[type=number]', f).forEach(function (i) { i.disabled = i.value === ''; });
      }
    });
    var timer;
    document.addEventListener('change', function (e) {
      var form = e.target.closest && e.target.closest('form[data-sf-filterform]');
      if (!form) return;
      var sortieren = e.target.matches('[data-sf-sort]');
      if (!sortieren && window.innerWidth <= MOBIL) return; /* Handy: erst „Ergebnisse anzeigen“ */
      clearTimeout(timer);
      timer = setTimeout(function () { absenden(form); }, sortieren ? 0 : 350);
    });
    document.addEventListener('click', function (e) {
      var t = e.target;
      var btn = t.closest && t.closest('[data-sf-filterpanel]');
      if (btn) {
        var form = btn.closest('form'), panel = form && form.querySelector('.fl-filter');
        if (panel) { var o = panel.classList.toggle('offen'); btn.setAttribute('aria-expanded', o ? 'true' : 'false'); }
        return;
      }
      if (window.innerWidth > MOBIL) {
        qa('.fdrop[open]').forEach(function (d) { if (!d.contains(t)) d.removeAttribute('open'); });
      }
    });
    document.addEventListener('toggle', function (e) {
      var d = e.target;
      if (d && d.classList && d.classList.contains('fdrop') && d.open && window.innerWidth > MOBIL) {
        qa('.fdrop[open]').forEach(function (o) { if (o !== d) o.removeAttribute('open'); });
      }
    }, true);
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      qa('.fdrop[open]').forEach(function (d) { d.removeAttribute('open'); var s = d.querySelector('summary'); if (s) s.focus(); });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
